import React from 'react';
import { WebsiteDesignProps } from './types';
import { Button } from "@/components/ui/button";

const MinimalistPortfolio: React.FC<WebsiteDesignProps> = ({ previewData }) => {
    const schoolName = previewData?.name || "Archive.";

    return (
        <div className="bg-white min-h-screen font-sans text-black">
            <nav className="fixed top-0 w-full p-8 flex justify-between items-center z-50 bg-white/80 backdrop-blur-sm">
                <div className="font-bold text-sm uppercase tracking-widest">{schoolName}</div>
                <div className="text-sm font-medium hover:line-through cursor-pointer">Menu</div>
            </nav>

            <main className="pt-32 px-8 container mx-auto">
                <section className="mb-32">
                    <h1 className="text-6xl md:text-[10rem] font-medium leading-[0.8] tracking-tighter mb-12">
                        Less <br/> is More.
                    </h1>
                    <div className="flex flex-col md:flex-row gap-12 items-start">
                        <p className="text-lg text-gray-500 max-w-sm leading-relaxed">
                            Focused education stripping away the noise. We concentrate on the essence of conceptual thinking and execution.
                        </p>
                        <Button variant="link" className="text-black p-0 h-auto font-medium text-lg uppercase tracking-wide hover:no-underline border-b border-black rounded-none pb-1">
                            Selected Works (24)
                        </Button>
                    </div>
                </section>

                <section className="grid grid-cols-1 md:grid-cols-2 gap-4 pb-20">
                     <div className="aspect-[3/4] bg-gray-100 flex items-center justify-center hover:scale-[0.98] transition-transform duration-500">
                         <span className="text-gray-400 text-xs uppercase tracking-widest">Project One</span>
                     </div>
                     <div className="aspect-[3/4] bg-gray-100 flex items-center justify-center hover:scale-[0.98] transition-transform duration-500 md:mt-24">
                         <span className="text-gray-400 text-xs uppercase tracking-widest">Project Two</span>
                     </div>
                </section>
            </main>
        </div>
    );
};

export default MinimalistPortfolio;
